import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { supportedLangs } from '@/i18n';
import { Globe } from 'lucide-react';
import { useState, useRef, useEffect } from 'react';

const langLabels = { lv: 'LV', en: 'EN', es: 'ES', lt: 'LT', et: 'ET' };

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const switchLang = (newLang) => {
    const pathAfterLang = location.pathname.replace(`/${lang}`, '') || '';
    navigate(`/${newLang}${pathAfterLang}${location.hash}`);
    i18n.changeLanguage(newLang);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-border hover:border-primary/50 transition-colors text-sm font-medium text-foreground/80 hover:text-primary"
        aria-label="Change language"
        data-testid="language-switcher-btn"
      >
        <Globe className="w-4 h-4" />
        {langLabels[lang] || 'LV'}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 bg-white rounded-xl shadow-lg border border-border py-1 min-w-[80px] z-50">
          {supportedLangs.map((l) => (
            <button
              key={l}
              onClick={() => switchLang(l)}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-secondary transition-colors ${l === lang ? 'text-primary font-semibold' : 'text-foreground/70'}`}
              data-testid={`lang-option-${l}`}
            >
              {langLabels[l]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
